<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="stowages.data"
      style="width: 100%"
      row-key="id"
      highlight-current-row
      :row-class-name="'pointer-row'"
      @sort-change="handleSortChange"
      @row-click="(row) => $router.replace('/sales/stowages/view/' + row.id)"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="70"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="stowage"
            :options="['settings', 'export', 'import']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :stowage="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div
      v-if="stowages.meta"
      class="el-card-footer"
    >
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="stowages.meta.per_page"
        layout="total, prev, pager, next"
        :total="stowages.meta.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import Actions from './Actions';
import TableSettings from '../../TableSettings';
import columns, { allColumns, labels, compareTypes } from './columns';

export default {
  components: {
    Actions,
    TableSettings,
    ...columns,
  },
  data() {
    return {
      labels,
      allColumns,
      tableKey: 0,
      currentPage: 1,
      currentSort: {
        prop: 'created_at',
        order: 'descending',
      },
    };
  },
  computed: {
    stowages() {
      return this.$store.getters['stowage/stowages'];
    },
    tableConfig() {
      return JSON.parse(JSON.stringify(this.$store.getters['stowage/tableConfig']));
    },
    loading() {
      return this.$store.getters['stowage/loading'];
    },
  },
  watch: {
    tableConfig() {
      this.tableKey++;
    },
  },
  async mounted() {
    this.$store.commit('stowage/setFilterString', '');
    this.$store.commit('stowage/setCurrentPage', this.currentPage);
    this.$store.commit('stowage/setSorting', this.currentSort);
    await this.$store.dispatch('stowage/fetchAll');
  },
  methods: {
    handleCurrentChange(val) {
      this.$store.commit('stowage/setCurrentPage', val);
      this.$store.dispatch('stowage/fetchAll');
    },
    handleSortChange({ column, prop, order }) {
      if (column.sortable === 'custom') {
        this.$store.commit('stowage/setSorting', {
          prop,
          order,
          compareType: compareTypes[prop] || 'string'
        });
        this.$store.dispatch('stowage/fetchAll');
      }
    },
  },
};
</script>
<style>
  .pointer-row {
    cursor: pointer;
  }
</style>
